// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonTogglePair_button__1jU4q","selected":"ButtonTogglePair_selected__3f90W","buttonPair":"ButtonTogglePair_buttonPair__2qYKh"};